"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "gattatico": {
    "5057d530": [{
      "hkey": "efdf1c7e",
      "slug": "ponte-enza",
      "name": "Ponte Enza",
      "primary": true,
      "skipSearch": false
    }],
    "enza": [{
      "hkey": "efdf1c7e",
      "slug": "ponte-enza",
      "name": "Ponte Enza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "gattatico"
    }],
    "3ea30ede": [{
      "hkey": "950d74f7",
      "slug": "nocetolo",
      "name": "Nocetolo",
      "primary": true,
      "skipSearch": false
    }],
    "noceto": [{
      "hkey": "950d74f7",
      "slug": "nocetolo",
      "name": "Nocetolo",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "da3d6a33": [{
      "hkey": "efdf1c7e",
      "slug": "ponte-enza",
      "name": "Ponte Enza",
      "primary": true,
      "skipSearch": false
    }],
    "ponte": [{
      "hkey": "efdf1c7e",
      "slug": "ponte-enza",
      "name": "Ponte Enza",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "71e6d4c5": [{
      "hkey": "8e2adb09",
      "slug": "praticello",
      "name": "Praticello",
      "primary": true,
      "skipSearch": false
    }],
    "praticello-sede-del-municipio": [{
      "hkey": "8e2adb09",
      "slug": "praticello",
      "name": "Praticello",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "be7b22c7": [{
      "hkey": "46ad47ea",
      "slug": "taneto",
      "name": "Taneto",
      "primary": true,
      "skipSearch": false
    }],
    "taneto-fiesso": [{
      "hkey": "46ad47ea",
      "slug": "taneto",
      "name": "Taneto",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;